<mat-form-field appearance="fill" class="my-mat-form-field">
  <mat-label>{{label}}</mat-label>
  <input *ngIf="!required" matInput [formControl]="form_control" [type]="type" (change)="changedValue($event)" [placeholder]="placeholder">
  <input *ngIf="required" matInput [formControl]="form_control" required [type]="type" (change)="changedValue($event)"  [placeholder]="placeholder">
  <mat-error *ngIf="form_control.invalid">{{errorMsg}}</mat-error>
</mat-form-field>
